import {useContext} from 'react';
import {view} from '@sail/ui/deprecated';

import {useIntl} from 'react-intl';
import {AvailabilityNotice} from '@stripe-internal/conversations-ui';
import {ChannelType} from '../Channel';
import {getDisplayChannels} from '../getDisplayChannels';
import {ConfigContext} from '../../../Providers/ConfigProvider';
import {OptionButton} from './OptionButton';
import {EligibleChannelsEndpointResponseChannel} from '../../../../generated/types';
import {Topic} from '../../TopicSelector';

export type Props = {
  eligibleChannels?: EligibleChannelsEndpointResponseChannel[] | null;
  noticeMessage?: string;
  selectedTopic?: Topic;
  onChannelSelected: (channel: ChannelType) => void;
  showUnavailableChannels?: boolean;
};

export function ChannelSelectorV2({
  eligibleChannels,
  noticeMessage,
  selectedTopic,
  onChannelSelected,
  showUnavailableChannels = false,
}: Props) {
  const {locale} = useIntl();
  const {disableTopicSelector} = useContext(ConfigContext);

  const displayChannels = getDisplayChannels({
    channels: eligibleChannels,
    selectedTopic,
    disableTopicSelector,
    locale,
    showUnavailableChannels,
  });

  return (
    <view.div data-testid="ChannelList">
      {noticeMessage && <AvailabilityNotice notice={noticeMessage} />}
      <view.div css={{marginTop: 'medium'}}>
        {displayChannels.map((channel: ChannelType) => (
          <OptionButton
            key={channel.type}
            title={channel.title}
            icon={channel.icon}
            disabled={channel.disabled}
            description={channel.waitEstimate}
            dataTestId={`channel-button-${channel.type}`}
            onClick={() => onChannelSelected(channel)}
          />
        ))}
      </view.div>
    </view.div>
  );
}
